import { LinkedInIcon, GitHubIcon, EmailIcon } from './icons';
import { profile } from '../data/profile';

export function SocialLinks({ className = '' }) {
  const { linkedin, github, email } = profile.socials;
  return (
    <div className={`social-row ${className}`}>
      <a href={linkedin} target="_blank" rel="noopener noreferrer" className="social-icon-link" aria-label="LinkedIn">
        <LinkedInIcon />
      </a>
      <a href={github} target="_blank" rel="noopener noreferrer" className="social-icon-link" aria-label="GitHub">
        <GitHubIcon />
      </a>
      <a href={`mailto:${email}`} className="social-icon-link" aria-label="Email">
        <EmailIcon />
      </a>
    </div>
  );
}
